import React from 'react';
import { Point } from 'leaflet';
import Connector from './Connector';
import { NeEdge } from './utils/MapHelper';

type Props = {
  lines: NeEdge[]
};

const ConnectionGenerator = ({ lines }: Props) => {
  const xcipioSourceTypes = new Set(['xcipio', 'xcipioCluster', 'admf', 'admfCluster', 'mdf2', 'mdf3', 'mdf2Cluster', 'mdf3Cluster']);
  const buildConnections = () => {
    return lines
    .map((edge: NeEdge) => {
      if (edge.destinationLocation) {
        return (
          <Connector
            type={xcipioSourceTypes.has(edge.sourceType) ? 'cf' : edge.sourceType}
            key={edge.edgeKey}
            startPoint={{
              x: edge.sourceLocation.lat,
              y: edge.sourceLocation.lng
            } as Point}
            endPoint={{
              x: edge.destinationLocation.lat,
              y: edge.destinationLocation.lng
            } as Point}
            lineStatus={edge.status || ''}
            tooltipData={edge.tooltipData || []}
          />
        )
      }
    });
  }

  return (
    <React.Fragment>
      {buildConnections()}
    </React.Fragment>
  );
};

export default ConnectionGenerator;
